export enum ReservationTab {
    Status = 'state',
    Properties = 'properties',
    Group = 'group',
    Pricing = 'pricing',
    Items = 'items',
    Mailing = 'mailing',
    ActionLog = 'eventlog',
    Summary = 'summary',
    Billing = 'billing',
    Contracts = 'contracts',
}
